
import { GalleryShowsItem } from '@/dataTypes/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    exhibition: {
      type: Object as PropType<GalleryShowsItem>,
      required: true,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    deleteShow() {
      this.$emit('delete', this.exhibition.id);
    },
    moveUp() {
      this.$emit('moveUp', this.exhibition.id);
    },
    moveDown() {
      this.$emit('moveDown', this.exhibition.id);
    },
  },
});
